<template>
    <div class="add_build_alerts">
        <el-checkbox style="margin:0 10px 10px 30px;color: #333333" v-model="addBuildInfo.whetherNo" @change="checkedChange">无单元</el-checkbox><span style="color: #FF8000">(勾选代表创建的房间没有单元)</span>
        <ul class="add_build_alert_building_info" v-if="!addBuildInfo.whetherNo" style="margin-top: 10px;">
            <li class="add_build_alert_building_info_item uiint_info">
                <span class="add_build_alert_building_info_title">
                    <i style="color:#F56C6C;padding-right:6px;">*</i>单元名称
                </span>
                <div class="add_build_alert_building_info_content">
                    <el-input class="uiint_info_prefix" placeholder="前缀" v-model="addBuildInfo.prefix"></el-input>
                    <el-input class="uiint_info_floor" placeholder v-model="addBuildInfo.number"></el-input>
                    <el-select class="uiint_info_unit" v-model="addBuildInfo.suffix" placeholder
                               @visible-change="getUnitData">
                        <el-option v-for="(item,index) in unitData" :key="index" :label="item.valueDesc"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>
            </li>
        </ul>
        <ul class="add_build_alert_building_info add_build_left">
            <li class="single_number">
                <div>
                    <span class="single_number_title">
                        <i style="color:#F56C6C;padding-right:6px;">*</i>单层户数
                    </span>
                    <div class="single_number_info">
                        <el-input v-model="addBuildInfo.elevatorNo"></el-input>
                        <span>梯</span>
                        <el-input v-model="addBuildInfo.households"></el-input>
                        <span>户</span>
                    </div>
                </div>
            </li>
            <li class="add_build_alert_building_info_item start_and_ending">
                <span class="add_build_alert_building_info_title">
                    <i style="color:#F56C6C;padding-right:6px;">*</i>楼层
                </span>
                <div class="add_build_alert_building_info_content">
                    <el-input placeholder="起始楼层" v-model="addBuildInfo.indexFloor"></el-input>
                    <span>—</span>
                    <el-input placeholder="结束楼层" v-model="addBuildInfo.lastFloor"></el-input>
                </div>
            </li>

        </ul>
        <ul class="building_rules">
            <li class="building_rules_item">
                <span>
                    <i style="color:#F56C6C;padding-right:6px;">*</i>房号规则
                </span>
                <el-select class="uiint_info_unit" v-model="addBuildInfo.roomNumberRule" placeholder
                           @change="changeHouseRule">
                    <el-option v-for="(item,index) in roomRuleData" :key="index" :label="item.valueDesc"
                               :value="item.value"></el-option>
                </el-select>
            </li>
            <li class="building_rules_item">
                <span>
                    <i style="color:#F56C6C;padding-right:6px;">*</i>规则组成
                </span>
                <div class="rules_item_content">
                    <el-input class="uiint_info_floor" style="border-rght:1px solid #606266 !important;"
                              placeholder="前缀" v-model="addBuildInfo.ruleCompositionPrefix"></el-input>
                    <!-- <el-select class="uiint_info_qianzhui" v-model="addBuildInfo.ruleComposition" placeholder="前缀" >
            <el-option v-for="(item,index) in ruleBeforeData" :key="index" :label="item.valueDesc" :value="item.value">
            </el-option>
                    </el-select>-->
                    <el-select class="uiint_info_unit" v-model="addBuildInfo.ruleCompositionSuffix" placeholder="请选择规则">
                        <el-option v-for="(item,index) in ruleAfterData" :key="index" :label="item.valueDesc"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>
            </li>
        </ul>
        <div class="alert_footer">
            <div class="foot_btns">
                <button class="cancel_btn" @click="removeTheBtn">取消</button>
                <button v-points class="save_btn" @click="saveBuildBtn">保存</button>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import { dicGet } from "@/api";
    export default {
        name: "",
        props:['curBuildData'],
        data() {
            return {
                isActive: true,
                buildType: [{ valueDesc: "栋", value: "BUILD" }], //栋座后缀
                unitData: [], //单元后缀
                roomRuleData: [
                    { valueDesc: "按楼层排号", value: "0" },
                    { valueDesc: "按单元排号", value: "1" },
                ], //房号规则
                ruleBeforeData: [
                    { valueDesc: "无", value: "1" },
                    { valueDesc: "楼层", value: "0" },
                ], //规则组成前缀
                ruleAfterData: [], //规则组成后缀
                useData: [], //用途列表
                landTermData: [], //土地期限列表
                buildingType: [], //建筑类型列表
                landNatureData: [], //土地性质列表
                droitNatureData: [], //权利性质列表
                structureData: [], //建筑结构列表
                buildAgesData: [], //建筑年代列表
                storeData: [], //负责人门店列表
                employeeData: [], //负责人列表
                addBuildInfo: {
                    number:'',
                    tungId:this.curBuildData.tungId,
                    whetherNo:false,
                    // employeeId: '', // 员工编号
                    residentialAreaId: "", // 小区编号
                    sort: "", // 顺序
                    tungNumber: "", //单个添加起始楼栋
                    indexTung: "", //  起始楼栋号
                    lastTung: "", //  结束楼栋号
                    suffix: "", //  栋座单位： 1、 栋 2、 弄 3、 座 4、 号楼 5、 胡同
                    prefix: "", //  楼栋前缀
                    indexFloor: "", // 起始楼层
                    lastFloor: "", //  结束楼层
                    // totalFloor: '', //   总层数
                    roomNumberRule: "", //   房号规则， 按楼层排号、 按单元排号 默认： 按楼层排号
                    ruleCompositionPrefix: "", //  组成规则前缀， 楼层、 无
                    ruleCompositionSuffix: "", //  组成规则后缀 数字、 字母
                    elevatorNo: "", //  梯数
                    households: "", //  户数
                    purpose: "", //  楼栋用途， 住宅、 别墅、 商铺、 写字楼、 厂房、 仓库、 车库
                    landTenure: "", //  土地期限， 40 年、 50 年、 70 年
                    // architecturalType: "", //  楼栋建筑类型: '',//
                    landCharacteristic: "", //  土地性质， 出让、 划拨
                    natureOfRights: "", //  权利性质
                    buildingStructure: "", // (required) 楼栋建筑结构
                    buildingYears: "", //  建筑年代
                    // liableEmployeeStoreId: '', //  责任人门店， 默认为当前登陆员工所属门店
                    // liableEmployeeId: '' //  责任人， 默认为本系统当前登陆员工
                },
                empId: "",
            };
        },
        mounted() {
            console.log(this.curBuildData)
            // this.employeeName = sessionStorage.getItem('name').replace('\"', '').replace('\"', '')
            let StoreId = parseInt(sessionStorage.getItem("storeId"));
            this.employeeData = [
                { name: this.employeeName, employeeId: this.empId },
            ];
        },

        methods: {
            checkedChange(){
                this.addBuildInfo.prefix = '';
                this.addBuildInfo.number = '';
                this.addBuildInfo.suffix = '';
            },
            getBuildType(val) {
                // 查询栋座类型
                if (val) {
                    let params = {
                        code: "tung",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.buildType = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },

            getUnitData(val) {
                // 查询单元

                if (val) {
                    let params = {
                        code: "unit",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.unitData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询规则组成前缀
            getRuleBeforerData(val) {
                if (val) {
                    let params = {
                        employeeId: this.empId,
                        code: "ruleBeforePrefixEnums",
                    };
                    getScreening(params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.ruleBeforeData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询规则组成
            getRuleAfterData(val) {
                if (val) {
                    let params = {
                        employeeId: this.empId,
                        code: "ruleAfterPrefixEnums",
                    };
                    getScreening(params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.ruleAfterData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询房号规则
            getRoomRuleData(val) {
                if (val) {
                    let params = {
                        employeeId: this.empId,
                        code: "houseRoomRuleEnums",
                    };
                    getScreening(params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.roomRuleData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },

            changeHouseRule() {
                //cosole.log(222222,this.addBuildInfo.roomNumberRule)
                if (this.addBuildInfo.roomNumberRule == 0) {
                    // 按照楼层排序
                    this.ruleAfterData = [
                        { valueDesc: "字母", value: "2" },
                        { valueDesc: "数字", value: "3" },
                    ];
                    //cosole.log(3333)
                } else {
                    this.ruleAfterData = [{ valueDesc: "数字", value: "3" }];
                    this.addBuildInfo.ruleCompositionSuffix = "3";
                    //cosole.log(355555)
                }
            },

            // 查询用途
            getUseData(val) {
                if (val) {
                    let params = {
                        code: "tungPurpose",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.useData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询土地期限
            getLandTermData(val) {
                if (val) {
                    let params = {
                        code: "landTenure",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.landTermData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询建筑类型
            getBuildingType(val) {
                if (val) {
                    let params = {
                        code: "tungArchitecturalType",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.buildingType = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询土地性质
            getLandNature(val) {
                if (val) {
                    let params = {
                        code: "landCharacteristic",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.landNatureData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询权利性质
            getDroitNature(val) {
                if (val) {
                    let params = {
                        code: "natureRights",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.droitNatureData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询建筑结构
            getStructureData(val) {
                if (val) {
                    let params = {
                        code: "buildingStructure",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.structureData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询建筑年代
            getBuildAgesData(val) {
                if (val) {
                    let params = {
                        code: "architectural_age",
                    };
                    this.$post(dicGet, params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.buildAgesData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 查询负责人门店
            getStoreData() {
                let params = {
                    employeeId: this.empId,
                };
                storeFind(params).then((res) => {
                    if (res.success) {
                        //cosole.log(res)
                        // let StoreId = parseInt(sessionStorage.getItem('storeId'))
                        this.storeData = res.data;
                        // for (let i in res.data) {
                        //   if (res.data[i].storeId == StoreId) {
                        //     this.addBuildInfo.liableEmployeeStoreId = StoreId
                        //   }
                        // }
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                        });
                    }
                });
            },
            // 查询负责人
            getEmployeeData(val) {
                if (val) {
                    let params = {
                        storeId: this.addBuildInfo.liableEmployeeStoreId,
                    };
                    employeesFind(params).then((res) => {
                        if (res.success) {
                            //cosole.log(res)
                            this.employeeData = res.data;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }
            },
            // 取消按钮
            removeTheBtn() {
                this.$emit("removUnitBtn");
            },
            // 保存按钮
            saveBuildBtn() {
                if (!this.addBuildInfo.whetherNo) {
                    if (!this.addBuildInfo.suffix) {
                        this.$message.error("请选择单元名称");
                        return false;
                    }
                }
                if (!this.addBuildInfo.elevatorNo&&!this.addBuildInfo.households) {
                    this.$message.error("请输入单层户数");
                    return false;
                }
                if (!this.addBuildInfo.indexFloor&&!this.addBuildInfo.lastFloor){
                    this.$message.error("请输入楼层");
                    return false;
                }
                if (!this.addBuildInfo.roomNumberRule){
                    this.$message.error("请选择房号规则");
                    return false;
                }
                if (!this.addBuildInfo.ruleCompositionSuffix){
                    this.$message.error("请选择规则组成");
                    return false;
                }
                this.$emit("saveUnitsBtn", this.addBuildInfo);
            },
        },
    };
</script>
<style type="text/css" lang="less">
    .add_build_alerts {
        .el-input {
            width: auto;
        }
        .add_build_left {
            /*display: flex;*/
            /*justify-content: space-between;*/
            padding: 0 40px;

            .content_add_type {
                .add_new_type {
                    font-size: 14px;
                }

                .add_type_chouse_btn {
                    border: 1px solid #5e75e6;
                    border-radius: 4px;
                    margin-top: 10px;
                    display: flex;

                    > li {
                        width: 120px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        font-size: 14px;
                        color: #5e75e6;
                        cursor: pointer;

                        &.active {
                            background: #5e75e6;
                            color: white;
                        }
                    }
                }
            }

            .single_number {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .single_number_info {
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    background: #f5f5f5;
                    padding-right: 10px;

                    > span {
                        font-size: 14px;
                        color: #232323;
                    }

                    .el-input {
                        .el-input__inner {
                            height: 30px;
                            width: 93.5px;
                            padding-left: 5px;
                            padding-right: 5px;
                            text-align: center;
                            border: none;
                            background: #f5f5f5;
                        }
                    }
                }
            }
        }

        .add_build_alert_building_info {
            display: flex;
            padding: 0 30px;
            margin-top: 20px;

            .add_build_alert_building_info_item {
                margin-right: 30px;
                .add_build_alert_building_info_content {
                    border: 1px solid #ccc;
                    background: #f5f5f5;
                    display: flex;
                    margin-top: 10px;
                    border-radius: 4px;
                    overflow: hidden;

                    .el-input {
                        .el-input__inner {
                            width: 65px;
                            height: 30px;
                            font-size: 14px;
                            background: #f5f5f5;
                            border: none;
                            border-right: 1px solid #ccc;
                            padding-left: 5px;
                            padding-right: 5px;
                            border-radius: 0;
                        }
                    }

                    .el-select {
                        .el-input {
                            .el-input__inner {
                                width: 65px;
                                height: 30px;
                                font-size: 14px;
                                background: #f5f5f5;
                                border: none;
                                padding-left: 6px;
                                padding-right: 10px;
                            }

                            .el-input__icon {
                                line-height: 30px;
                                width: 16px;
                                right: 0;
                            }
                        }
                    }
                }

                &.start_and_ending {
                    margin-left: 50px;

                    .add_build_alert_building_info_content {
                        align-items: center;

                        .el-input {
                            .el-input__inner {
                                width: 105px;
                                border: none;
                                text-align: center;
                            }
                        }
                    }
                }

                &.uiint_info {
                    .add_build_alert_building_info_content {
                        align-items: center;

                        .uiint_info_prefix {
                            .el-input__inner {
                                width: 50px;
                                border-right: 1px solid #ccc !important;
                                text-align: center;
                            }
                        }

                        .uiint_info_floor {
                            .el-input__inner {
                                width: 95px;
                                border: none;
                                text-align: center;
                            }
                        }

                        .uiint_info_unit {
                            .el-input {
                                .el-input__inner {
                                    width: 80px;
                                    border-left: 1px solid #ccc;
                                }
                            }
                        }
                    }
                }
            }
        }

        .building_rules {
            display: flex;
            padding: 0 30px;
            margin-top: 20px;

            .building_rules_item {
                display: flex;
                flex-direction: column;
                margin-right: 50px;

                > span {
                    font-size: 14px;
                    color: #232323;
                }

                .haoshi_el_input {
                    margin-top: 10px;

                    .el-input__inner {
                        width: 300px;
                        height: 30px;
                        background: #f5f5f5;
                    }
                }

                .el-date-editor {
                    .el-input__inner {
                        width: 150px !important;
                        height: 30px !important;
                        font-size: 14px;
                        background: #f5f5f5;
                        border: 1px solid #dcdfe6 !important;
                        border: none;
                        padding-left: 30px;
                        padding-right: 10px;
                        margin-top: 10px;
                    }

                    .el-input__icon {
                        display: none;
                        line-height: 30px !important;
                        width: 16px;
                        top: 5px;
                    }
                }

                .el-select {
                    margin-top: 10px;

                    .el-input {
                        .el-input__inner {
                            width:227px;
                            height: 30px;
                            background: #f5f5f5;
                        }

                        .el-input__icon {
                            line-height: 30px;
                        }
                    }
                }

                .rules_item_content {
                    display: flex;
                    margin-top: 10px;
                    border: 1px solid #ccc;
                    width: 227.2px;
                    height: 30px;
                    overflow: hidden;
                    border-radius: 4px;

                    .el-input {
                        min-width: 110px;

                        .el-input__inner {
                            min-width: 113.6px;
                            height: 30px;
                            border: none;
                            background: #f5f5f5;
                            // border-right: 1px solid #ccc;
                            border-radius: 0;
                            box-sizing: border-box;
                        }

                        .el-input__icon {
                            line-height: 30px;
                        }
                    }

                    .el-select {
                        margin-top: 0;

                        .el-input {
                            .el-input__inner {
                                width: 110px;
                                height: 30px;
                                border: none;
                            }

                            .el-input__icon {
                                line-height: 30px;
                            }
                        }
                    }

                    .uiint_info_qianzhui {
                        .el-input {
                            .el-input__inner {
                                height: 30px;
                                border-right: 1px solid #ccc;
                            }

                            .el-input__icon {
                                line-height: 30px;
                                display: none;
                            }
                        }
                    }
                }
            }

            &.last_building_rule {
                margin-bottom: 30px;
            }
        }

        .alert_footer {
            height: 80px;
            background: #f5f5f5;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 30px;

            .foot_btns {
                margin-right: 40px;

                > button {
                    width: 80px;
                    height: 40px;
                    border-radius: 4px;
                    outline: none;
                    border: none;
                    font-size: 16px;
                    color: #ffffff;

                    &.cancel_btn {
                        background: #999999;
                        margin-right: 20px;
                    }

                    &.save_btn {
                        background: #5e75e6;
                    }
                }
            }
        }
    }
</style>
